(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smartnest-product-polish"] && !Shopify.designMode) return;
  try {
    (() => {
    const compactDelivery = (root = document) => {
      root.querySelectorAll('.product-information .product-details .text-block').forEach(block => {
        const card = block.firstElementChild;
        const heading = card?.firstElementChild;
        if (card?.tagName === 'DIV' && heading?.textContent.trim().toUpperCase() === 'UAE PRICE & DELIVERY') {
          card.classList.add('sn-delivery-card');
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => compactDelivery(), { once: true });
    else compactDelivery();
    document.addEventListener('shopify:section:load', event => compactDelivery(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
